import React, { useEffect, useState } from 'react';
import favicon from './resources/img/favicon_conta.png';

// Estilos inline para evitar problemas de importação
const styles = {
  container: {
    position: 'fixed',
    bottom: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    padding: '12px 16px',
    maxWidth: '90%',
    width: '340px',
    zIndex: 9999,
    border: '1px solid #e0e0e0',
    animation: 'slideUp 0.3s ease-out forwards'
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    flex: 1
  },
  icon: {
    width: '36px',
    height: '36px',
    marginRight: '12px',
    borderRadius: '8px'
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  title: {
    fontSize: '14px',
    marginBottom: '2px',
    fontWeight: 'bold'
  },
  subtitle: {
    fontSize: '12px',
    color: '#666'
  },
  installButton: {
    backgroundColor: '#34D175',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '8px 16px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    marginLeft: '16px',
    whiteSpace: 'nowrap'
  },
  closeButton: {
    background: 'transparent',
    border: 'none',
    color: '#999',
    fontSize: '20px',
    cursor: 'pointer',
    padding: '0 0 0 10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};

const InstallPWA = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      console.log('Installation prompt captured');
      setSupportsPWA(true);
      setPromptInstall(e);
      setIsVisible(true);
    };
    
    window.addEventListener('beforeinstallprompt', handler);

    // Check if app is already installed
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    if (isStandalone) {
      setSupportsPWA(false);
      setIsVisible(false);
    }

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) {
      return;
    }
    promptInstall.prompt();
    
    // Wait for the user to respond to the prompt
    promptInstall.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the install prompt');
        setIsVisible(false);
      } else {
        console.log('User dismissed the install prompt');
      }
    });
  };

  const onClose = () => {
    setIsVisible(false);
    // Store in local storage that user dismissed the prompt
    localStorage.setItem('pwaPromptDismissed', Date.now().toString());
  };

  // Don't show if not supported or not visible
  if (!supportsPWA || !isVisible) {
    return null;
  }

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <img src={favicon} alt="Exoss Conta" style={styles.icon} />
        <div style={styles.textContainer}>
          <strong style={styles.title}>Instalar App</strong>
          <span style={styles.subtitle}>Acesse mais rápido</span>
        </div>
      </div>
      <button style={styles.installButton} onClick={onClick}>
        Instalar
      </button>
      <button style={styles.closeButton} onClick={onClose}>
        &times;
      </button>
    </div>
  );
};

export default InstallPWA;
